import Amplify, { Auth } from "aws-amplify";
import moment from "moment";

import store from "../store";

// ログイン/ログアウト時に、アプリ状態を初期化する。
async function initialize() {
  // 全stateの初期化
  await store.dispatch("auth/resetState");
  await store.dispatch("notification/resetState");
  await store.dispatch("profile/resetState");
  await store.dispatch("application/resetState");
  await store.dispatch("service-account/resetState");
  await store.dispatch("asig-project/resetState");
  await store.dispatch("email-verification/resetState");
}

export function amplifyConfigure(region, userPoolId, userPoolWebClientId) {
  Amplify.configure({
    Auth: {
      region,
      userPoolId,
      userPoolWebClientId,
    },
  });
}

export async function authenticatedUser() {
  return Auth.currentAuthenticatedUser()
    .then((data) => {
      if (data && data.signInUserSession) {
        return data;
      }

      return null;
    })
    .catch(() => null);
}

export function currentSession() {
  return Auth.currentSession();
}

export async function signIn(username, password) {
  // TODO: 位置をかえる
  await initialize();
  await store.dispatch("application/updateLastAccessDate", moment());
  return Auth.signIn(username, password);
}

export async function signOut() {
  await initialize();
  return Auth.signOut();
}
